import React, { Suspense } from "react";
import RouteLoading from "../components/common/RouteLoading";
import Header from "../components/common/Header";
import CommonSideBar from "../components/common/CommonSideBar";
import Footer from "../components/common/Footer";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Skeleton = () => {
   const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

   if (!isLoggedIn) {
      return <Navigate to={"/login"} />;
   }
   return (
      <div className="wrapper">
         <Header />
         <CommonSideBar />
         <div className="content-wrapper">
            <section className="content pb-5">
               <div className="container-fluid">
                  <Suspense fallback={<RouteLoading />}>
                     <Outlet />
                  </Suspense>
               </div>
            </section>
         </div>
         <Footer />
      </div>
   );
};

export default Skeleton;
